<template>
    <div class="dashboard-mobile-menu">
        <div class="overlay" ref="overlay">
            <div class="logo" v-on:click="navToggle">
                <router-link :to="{name: 'home'}">
                    <img src="/dist/images/logo-w.svg" alt="">
                </router-link>
            </div>

            <div class="menu" ref="navToggle" v-on:click="navToggle">
                <div class="block-menu">
                    <div class="block">
                        <p class="desc">{{__('Explore')}}</p>
                        <router-link :to="{name: 'home'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3081 7.15507L11.3381 2.98749C10.564 2.33832 9.43479 2.33832 8.66062 2.98749L3.69063 7.15507C2.93563 7.7884 2.49902 8.04419 2.49902 9.70919V15C2.49902 16.6667 3.33236 17.5 4.99902 17.5H14.999C16.6657 17.5 17.499 16.6667 17.499 15V9.70919C17.4999 8.04335 17.064 7.7884 16.3081 7.15507ZM13.7749 11.1083L11.9124 12.9708C11.409 13.4741 10.5906 13.4742 10.0881 12.9717L9.02897 11.9142L7.10901 13.7742C6.98734 13.8959 6.82732 13.9575 6.66732 13.9575C6.50732 13.9575 6.34729 13.8967 6.22563 13.7742C5.98146 13.5301 5.98146 13.1342 6.22563 12.89L8.08567 11.03C8.58984 10.5275 9.40904 10.5267 9.91154 11.0292L10.9707 12.0867L12.8923 10.2242C13.1365 9.98005 13.5323 9.98005 13.7765 10.2242C14.0207 10.4684 14.019 10.8641 13.7749 11.1083Z" />
                            </svg>
                            <p>{{__('web_Home')}}</p>
                        </router-link>
                        <router-link :to="{name: 'wallets'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.8238 3.75918L13.2713 4.68671C13.2113 4.78754 13.1022 4.84916 12.9847 4.84916H7.01383C6.89633 4.84916 6.78717 4.78754 6.72717 4.68671L6.17384 3.75755C5.84384 3.20255 6.24301 2.49921 6.88884 2.49921H13.1072C13.7547 2.50004 14.1547 3.20418 13.8238 3.75918ZM16.6663 12.5C16.6663 14.1667 15.833 17.5 9.99967 17.5C4.16634 17.5 3.33301 14.1667 3.33301 12.5C3.33301 9.73252 5.05883 7.53667 6.4205 6.19417C6.48383 6.13167 6.56633 6.09998 6.65467 6.09998H13.3447C13.433 6.09998 13.5164 6.13167 13.5789 6.19417C14.9405 7.53667 16.6663 9.73252 16.6663 12.5ZM12.083 13.0109C12.083 12.1534 11.508 11.4067 10.6813 11.1942L9.62718 10.9284C9.49385 10.8934 9.38052 10.8184 9.29385 10.7059C9.21135 10.6001 9.16634 10.4633 9.16634 10.3225C9.16634 9.97832 9.43718 9.69922 9.77051 9.69922H10.2297C10.5372 9.69922 10.7947 9.93756 10.8297 10.2542C10.8672 10.5976 11.1713 10.8425 11.5197 10.8067C11.863 10.7692 12.1097 10.4592 12.0722 10.1167C11.9822 9.30253 11.3872 8.66414 10.6247 8.49581V8.33335C10.6247 7.98835 10.3447 7.70835 9.99967 7.70835C9.65467 7.70835 9.37467 7.98835 9.37467 8.33335V8.49418C8.54217 8.67835 7.91634 9.42666 7.91634 10.3225C7.91634 10.74 8.0555 11.1483 8.303 11.4683C8.55383 11.7975 8.91301 12.035 9.31801 12.1392L10.3722 12.405C10.6438 12.475 10.833 12.7242 10.833 13.0109C10.833 13.1776 10.7689 13.335 10.6514 13.4542C10.5372 13.5709 10.3872 13.6342 10.2288 13.6342H9.76967C9.46217 13.6342 9.20467 13.3958 9.16967 13.0791C9.13134 12.7358 8.82717 12.4892 8.47967 12.5267C8.13634 12.5642 7.88967 12.8742 7.92717 13.2167C8.01717 14.0308 8.61217 14.6692 9.37467 14.8376V15C9.37467 15.345 9.65467 15.625 9.99967 15.625C10.3447 15.625 10.6247 15.345 10.6247 15V14.8392C10.9697 14.7634 11.2872 14.5909 11.5422 14.3317C11.8914 13.9775 12.083 13.5084 12.083 13.0109Z" />
                            </svg>
                            <p>{{__('web_Wallet')}}</p>
                        </router-link>
                        <router-link :to="{name: 'exchange'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0003 1.66669C5.39783 1.66669 1.66699 5.39752 1.66699 10C1.66699 14.6025 5.39783 18.3334 10.0003 18.3334C14.6028 18.3334 18.3337 14.6025 18.3337 10C18.3337 5.39752 14.6028 1.66669 10.0003 1.66669ZM5.25606 8.98928C5.16023 8.75595 5.2128 8.48666 5.39197 8.30833L7.89197 5.80833C8.13613 5.56416 8.532 5.56416 8.77616 5.80833C9.02033 6.0525 9.02033 6.44836 8.77616 6.69253L7.34285 8.12583H12.5003C12.8453 8.12583 13.1253 8.40583 13.1253 8.75083C13.1253 9.09583 12.8453 9.37583 12.5003 9.37583H5.83366C5.58033 9.375 5.35273 9.22261 5.25606 8.98928ZM14.6087 11.6917L12.1087 14.1917C11.987 14.3134 11.827 14.375 11.667 14.375C11.507 14.375 11.347 14.3142 11.2253 14.1917C10.9811 13.9475 10.9811 13.5517 11.2253 13.3075L12.6586 11.8742H7.50033C7.15533 11.8742 6.87533 11.5942 6.87533 11.2492C6.87533 10.9042 7.15533 10.6242 7.50033 10.6242H14.167C14.4203 10.6242 14.6479 10.7766 14.7446 11.0099C14.8413 11.2441 14.7879 11.5134 14.6087 11.6917Z" />
                            </svg>
                            <p>{{__('web_Exchange')}}</p>
                        </router-link>
                        <router-link :to="{name: 'cards'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.5 6.66669V7.70835H2.5V6.66669C2.5 5.00002 3.33333 4.16669 5 4.16669H15C16.6667 4.16669 17.5 5.00002 17.5 6.66669ZM17.5 8.95835V13.3334C17.5 15 16.6667 15.8334 15 15.8334H5C3.33333 15.8334 2.5 15 2.5 13.3334V8.95835H17.5ZM8.95833 12.5C8.95833 12.155 8.67833 11.875 8.33333 11.875H5.83333C5.48833 11.875 5.20833 12.155 5.20833 12.5C5.20833 12.845 5.48833 13.125 5.83333 13.125H8.33333C8.67833 13.125 8.95833 12.845 8.95833 12.5Z" />
                            </svg>
                            <p>{{__('web_Cards')}}</p>
                        </router-link>
                        <router-link :to="{name: 'affiliate'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.625 15.2916C15.625 16.985 14.6825 17.9167 12.9725 17.9167H7.02749C5.31749 17.9167 4.375 16.9841 4.375 15.2916C4.375 13.385 5.4583 11.1583 8.51247 11.1583H11.4867C14.5417 11.1575 15.625 13.385 15.625 15.2916ZM10.0067 9.5933C11.625 9.5933 12.9409 8.28248 12.9409 6.67165C12.9409 5.05998 11.6242 3.75 10.0067 3.75C8.38921 3.75 7.07336 5.06082 7.07336 6.67165C7.07336 8.28248 8.38838 9.5933 10.0067 9.5933ZM15.6584 7.44171H14.3167C14.2 7.44171 14.1 7.52503 14.075 7.63336C13.8917 8.42503 13.475 9.13332 12.9 9.67499C12.7583 9.80832 12.8417 10.0417 13.0333 10.0917C14.5083 10.4417 15.5333 11.3083 16.1417 12.4083C16.1833 12.5 16.2667 12.5583 16.375 12.5583H16.725C18.0333 12.5583 18.75 11.8417 18.75 10.5417C18.75 9.11669 17.9417 7.44171 15.6584 7.44171ZM14.5917 2.08333C13.76 2.08333 13.0341 2.53913 12.6533 3.2133C12.6225 3.2683 12.6241 3.32915 12.6358 3.38165C12.6483 3.43665 12.6725 3.46588 12.7242 3.50922C13.54 4.19672 14.0842 5.19253 14.1734 6.31836C14.1784 6.38169 14.2 6.42086 14.2384 6.46169C14.2767 6.50252 14.3342 6.52745 14.41 6.53412C14.4692 6.53912 14.53 6.54246 14.5917 6.54246C15.8167 6.54246 16.8167 5.54252 16.8167 4.30918C16.8167 3.08335 15.8167 2.08333 14.5917 2.08333ZM1.25 10.5417C1.25 11.8417 1.96671 12.5583 3.27504 12.5583H3.62498C3.73331 12.5583 3.81667 12.5 3.85834 12.4083C4.46667 11.3083 5.49165 10.4417 6.96665 10.0917C7.15832 10.0417 7.24168 9.80832 7.10002 9.67499C6.52502 9.13332 6.10832 8.42503 5.92499 7.63336C5.89999 7.52503 5.79996 7.44171 5.68329 7.44171H4.34163C2.0583 7.44171 1.25 9.11669 1.25 10.5417ZM3.18329 4.30837C3.18329 5.5417 4.18333 6.54165 5.40833 6.54165C5.46999 6.54165 5.53084 6.5383 5.59001 6.5333C5.66667 6.52664 5.72328 6.50171 5.76162 6.46088C5.79995 6.42004 5.82162 6.38088 5.82662 6.31755C5.91579 5.19171 6.45996 4.1958 7.2758 3.5083C7.32663 3.46497 7.3517 3.43584 7.3642 3.38084C7.37586 3.32834 7.37753 3.26832 7.3467 3.21248C6.96503 2.53832 6.23999 2.08252 5.40833 2.08252C4.18333 2.08335 3.18329 3.08337 3.18329 4.30837Z" />
                            </svg>
                            <p>{{__('web_Referral program')}}</p>
                        </router-link>
                    </div>
                    <div class="block">
                        <p class="desc">{{__('Main Menu')}}</p>
                        <router-link :to="{name: 'support'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0003 1.66669C5.39783 1.66669 1.66699 5.39752 1.66699 10C1.66699 14.6025 5.39783 18.3334 10.0003 18.3334C14.6028 18.3334 18.3337 14.6025 18.3337 10C18.3337 5.39752 14.6028 1.66669 10.0003 1.66669ZM10.017 14.5834C9.55701 14.5834 9.1794 14.21 9.1794 13.75C9.1794 13.29 9.54867 12.9167 10.0087 12.9167H10.017C10.4778 12.9167 10.8503 13.29 10.8503 13.75C10.8503 14.21 10.477 14.5834 10.017 14.5834ZM11.3362 10.4401C10.727 10.8484 10.6136 11.0759 10.5928 11.1359C10.5053 11.3967 10.262 11.5617 10.0003 11.5617C9.93449 11.5617 9.86779 11.5517 9.80196 11.5292C9.47446 11.4192 9.29871 11.065 9.40788 10.7375C9.55871 10.2875 9.94957 9.86336 10.6396 9.40086C11.4904 8.83086 11.3812 8.20592 11.3453 8.00092C11.2512 7.45592 10.792 6.99159 10.2528 6.89659C9.84281 6.82159 9.44208 6.92909 9.12874 7.19159C8.81374 7.45576 8.63273 7.84495 8.63273 8.25828C8.63273 8.60328 8.35273 8.88328 8.00773 8.88328C7.66273 8.88328 7.38273 8.60328 7.38273 8.25828C7.38273 7.47411 7.72615 6.73665 8.32532 6.23415C8.91865 5.73748 9.69946 5.53006 10.4703 5.66673C11.5261 5.85339 12.392 6.72583 12.5762 7.7875C12.7595 8.83916 12.3187 9.78175 11.3362 10.4401Z" />
                            </svg>
                            <p>{{__('web_Support')}}</p>
                        </router-link>
                        <router-link :to="{name: 'setting'}">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.3583 12.1667C16.5833 11.7167 16.1083 10.8917 16.1083 10C16.1083 9.10833 16.5833 8.28333 17.3583 7.83333C17.4917 7.74999 17.5417 7.58334 17.4583 7.45L16.0667 5.05C16.0167 4.95833 15.925 4.90835 15.8333 4.90835C15.7833 4.90835 15.7333 4.925 15.6917 4.95C15.3083 5.16667 14.875 5.28333 14.4417 5.28333C14 5.28333 13.5667 5.16666 13.175 4.94166C12.4 4.49166 11.925 3.675 11.925 2.78333C11.925 2.625 11.8 2.5 11.65 2.5H8.34999C8.19999 2.5 8.075 2.625 8.075 2.78333C8.075 3.675 7.6 4.49166 6.825 4.94166C6.43334 5.16666 6.00001 5.28333 5.55834 5.28333C5.12501 5.28333 4.69168 5.16667 4.30834 4.95C4.17501 4.86667 4.00833 4.91666 3.93333 5.05L2.53334 7.45C2.50834 7.49167 2.5 7.54167 2.5 7.58334C2.5 7.68334 2.55001 7.77499 2.64168 7.83333C3.41668 8.28333 3.89168 9.09999 3.89168 9.99166C3.89168 10.8917 3.41666 11.7167 2.64999 12.1667H2.64168C2.50834 12.25 2.45832 12.4167 2.54166 12.55L3.93333 14.95C3.98333 15.0417 4.075 15.0917 4.16667 15.0917C4.21667 15.0917 4.26668 15.075 4.30834 15.05C5.09168 14.6083 6.05 14.6083 6.825 15.0583C7.59167 15.5083 8.06666 16.325 8.06666 17.2167C8.06666 17.375 8.19166 17.5 8.34999 17.5H11.65C11.8 17.5 11.925 17.375 11.925 17.2167C11.925 16.325 12.4 15.5083 13.175 15.0583C13.5667 14.8333 14 14.7167 14.4417 14.7167C14.875 14.7167 15.3083 14.8333 15.6917 15.05C15.825 15.1333 15.9917 15.0833 16.0667 14.95L17.4667 12.55C17.4917 12.5083 17.5 12.4583 17.5 12.4167C17.5 12.3167 17.45 12.225 17.3583 12.1667ZM10 12.5C8.61667 12.5 7.5 11.3833 7.5 10C7.5 8.61667 8.61667 7.5 10 7.5C11.3833 7.5 12.5 8.61667 12.5 10C12.5 11.3833 11.3833 12.5 10 12.5Z" fill/>
                            </svg>
                            <p>{{__('web_Settings')}}</p>
                        </router-link>
                    </div>
                </div>
                <div class="dashboard-menu__bottom">
                    <div class="left">
                        <img class="img" src="/dist/images/img-support.svg" alt="">
                        <div>
                            <p>{{user.name}}</p>
                            <span>{{user.email}}</span>
                        </div>
                    </div>
                    <div class="right">
                        <a :href="'/ajax/logout'">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 12.75H15V17V18C15 20 14 21 12 21H6C4 21 3 20 3 18V6C3 4 4 3 6 3H12C14 3 15 4 15 6V7V11.25H8C7.586 11.25 7.25 11.586 7.25 12C7.25 12.414 7.586 12.75 8 12.75ZM21.692 11.713C21.654 11.621 21.599 11.538 21.53 11.469L18.53 8.46899C18.237 8.17599 17.762 8.17599 17.469 8.46899C17.176 8.76199 17.176 9.237 17.469 9.53L19.189 11.25H15V12.75H19.189L17.469 14.47C17.176 14.763 17.176 15.238 17.469 15.531C17.615 15.677 17.807 15.751 17.999 15.751C18.191 15.751 18.383 15.678 18.529 15.531L21.529 12.531C21.598 12.462 21.653 12.379 21.691 12.287C21.768 12.103 21.768 11.897 21.692 11.713Z" />
                            </svg>
                        </a>

                    </div>
                </div>

            </div>



            <div class="social">

            </div>
        </div>

        <div class="navBurger" role="navigation" ref="navToggle" v-on:click="navToggle"></div>
    </div>
</template>

<script>
    export default {
        name: 'DashboardMenuMobile',
        data: function() {
            return {
            }
        },
        props: {

        },

        computed: {
            resp_tickets() {
                return this.$store.state.preference.resp_tickets
            },
            user() {
                return this.$store.getters.user
            },
        },
        methods: {
            navToggle: function () {
                this.$refs.navToggle.classList.toggle('active');
                this.$refs.overlay.classList.toggle('open');
            }
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-mobile-menu .block-menu{
        width: 300px;
    }
    .dashboard-mobile-menu .block-menu .desc{
        margin-bottom: 12px;
        font-size: 12px;
        color: #667085;
        font-family: AeonikMedium;
    }
    .dashboard-mobile-menu .block-menu a{
        height: 42px;
        padding: 0px 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        border-radius: 10px;
        background-color: transparent;
        color: #344054;
        text-decoration: none;
    }
    .dashboard-mobile-menu .block-menu a p{
        padding-left: 8px;
    }
    .dashboard-mobile-menu .block-menu a svg{
        fill: #344054;
    }
    .dashboard-mobile-menu .block-menu .router-link-exact-active{
        background-color: #6E56FA;
        color: #ffffff;
    }
    .dashboard-mobile-menu .block-menu .router-link-exact-active svg{
        fill: #FFFFFF;
    }
    .dashboard-mobile-menu .block-menu .block{
        margin-bottom: 30px;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom{
        border-radius: 14px;
        background: #F8F8F8;
        padding: 0px 12px;
        height: 70px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        width: 100%;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .left{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .left .img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .left p{
        color: #344054;
        font-family: AeonikMedium;
        margin-top: -2px;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .left span{
        font-size: 12px;
        color: #667085;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .right a{
        display: inline-block;
    }
    .dashboard-mobile-menu .dashboard-menu__bottom .right svg{
        fill: #667085;
    }


    .dashboard-mobile-menu {
        display: none;

        .overlay {
            padding-top: 40px;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transform-origin: left top;
            transform: scale(0);
            visibility: hidden;
            transition: all 0.4s ease-in-out;
            z-index: +4;
            background: linear-gradient(180deg, #E5E6FE 0%, #F3F5F7 30.16%);
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .overlay.open {
            opacity: 1;
            visibility: visible;
            transform: scale(1);
            z-index: +4;
            position: fixed;
            min-height: 100vh;
            height: 100%;
        }

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 40px;
        }

        .menu {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 0px;

            &__item {

                .block-link {
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                    height: 36px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 17px;
                    color: #344054;
                    background: transparent;
                    transition-duration: .3s;
                    position: relative;


                    &__icon {
                        margin-right: 12px;
                    }

                    &:hover {
                        color: #6E56FA;
                        transition-duration: .3s;
                    }

                    .dot-mess {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background-color: #6E56FA;
                        animation: glowing 1200ms infinite;
                        position: absolute;
                        right: -16px;
                        top: 14px;
                    }
                }

                .block-link.router-link-exact-active {
                    color: #6E56FA;
                    transition-duration: .3s;
                }
            }
        }

        .powered {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 0 30px;

            &__text {
                font-weight: 600;
                font-size: 8px;
                line-height: 8px;
                letter-spacing: 0.18em;
                text-transform: uppercase;
                color: #999999;
                margin-right: 8px;
                cursor: default;
            }
        }

        .social {
            display: flex;
            align-items: center;

            svg {
                margin: 0 12px;
            }
        }

        .navBurger {
            display: none;
            position: absolute;
            left: 20px;
            top: 28px;
            cursor: pointer;
            background: #000;
            box-sizing: border-box;
            background-clip: content-box;
            width: 20px;
            padding-left: 0;
            padding-right: 0;
            height: 15px;
            border-top: 6px solid transparent;
            border-bottom: 7px solid transparent;
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: all 0.25s ease-in-out;
            transition: all 0.25s ease-in-out;
            z-index: +4;
        }
        .navBurger:before, .navBurger:after {
            content: "";
            position: absolute;
            background: #000;
            height: 2px;
            width: 20px;
            left: 0;
            will-change: rotate;
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: all 0.5s ease;
            transition: all 0.5s ease;
        }

        .navBurger:before {
            top: -6px;
        }
        .navBurger:after {
            bottom: -6px;
        }
        .navBurger.active {
            margin-top: 0;
            left: 22px;
            position: fixed;
            z-index: +4;
            background: transparent;
            background-clip: content-box;
        }
        .navBurger.active:before {
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
            top: 0;
            background: #202934;
            width: 100%;
        }
        .navBurger.active:after {
            bottom: 0;
            -webkit-transform: rotate(-135deg);
            transform: rotate(-135deg);
            background: #202934;
            width: 100%;
        }
    }


    @media only screen and (max-width : 1024px){
        .dashboard-mobile-menu{
            display: block;

            .navBurger{
                display: block;
            }
        }
    }

    @keyframes glowing {
        0% { background-color: #01AA4F; box-shadow: 0 0 0 #01AA4F; }
        50% { background-color: #2ba805; box-shadow: 0 0 7px #2ba805; }
        100% { background-color: #01AA4F; box-shadow: 0 0 0 #01AA4F; }
    }

</style>
